import './style.scss';
import ContactUsActive from '../../Images/sidebar/activeIcons/ContactUsActive.svg';
import HelpActive from '../../Images/sidebar/activeIcons/HelpActive.svg';
import MyImageActiveIcon from '../../Images/sidebar/activeIcons/MyImagesActiveIcon.svg';
import PricingActive from '../../Images/sidebar/activeIcons/PricingActive.svg';
import ShowCaseActive from '../../Images/sidebar/activeIcons/ShowCaseActive.svg';
import UserSettingActive from '../../Images/sidebar/activeIcons/UserSettingActive.svg';
import CreditActive from '../../Images/sidebar/activeIcons/CreditActive.svg';
import MyImageIcon from '../../Images/sidebar/MyImagesIcon.svg';
import ShowcaseIcon from '../../Images/sidebar/ShowcaseIcon.svg';
import CreditIcon from '../../Images/sidebar/CreditIcon.svg';
import PricingIcon from '../../Images/sidebar/PricingIcon.svg';
import ContactUsIcon from '../../Images/sidebar/ContactUsIcon.svg';
import HelpIcon from '../../Images/sidebar/HelpIcon.svg';
import UserSettingIcon from '../../Images/sidebar/UserSettingIcon.svg';
import LogoutIcon from '../../Images/sidebar/LogoutIcon.svg';
import metaModelLogo from '../../Images/sidebar/Logo_MetaModel.svg';
import { useEffect, useState } from 'react';
import closeCrossIcon from '../../Images/Mobile_Header/closeCrossIcon.svg';
import logInIcon from '../../Images/Mobile_Header/logInIcon.svg';
import {
  useLocation,
  useNavigate,
  useSearchParams,
  Link,
} from 'react-router-dom';
import useLogout from '../../hooks/useLogout';
import useAuthContext from '../../hooks/useAuthContext';
import { useDispatch } from 'react-redux';
import { resetForStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import useCreditContext from '../../hooks/useCreditContext';
import GoogleCalendarButton from '../../component/GoogleCalendarButton';
import DashboardIcon from '../../Images/sidebar/DashboardIcon.svg';
import DashboardActiveIcon from '../../Images/sidebar/activeIcons/DashboardActiveIcon.svg';

const MobileMenu = ({ handleClose }) => {
  const initialMenuContent = [
    // {
    //   id: 1,
    //   type: 'link',
    //   text: 'My Images',
    //   isAuthenticated: true,
    //   isActive: false,
    //   path: '/my-images',
    //   defaultIcon: MyImageIcon,
    //   activeIcon: MyImageActiveIcon,
    // },
    // {
    //   id: 2,
    //   type: 'link',
    //   text: 'Showcase',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/showcase',
    //   defaultIcon: ShowcaseIcon,
    //   activeIcon: ShowCaseActive,
    // },
    // { id: 3, type: 'break', isAuthenticated: false },
    {
      id: 3,
      type: 'link',
      text: 'Dashboard',
      isAuthenticated: true,
      isActive: false,
      path: '/dashboard',
      defaultIcon: DashboardIcon,
      activeIcon: DashboardActiveIcon,
    },
    {
      id: 4,
      type: 'link',
      text: 'Credit',
      isAuthenticated: true,
      isActive: false,
      // path: '/user-setting?from=credit',
      defaultIcon: CreditIcon,
      activeIcon: CreditActive,
    },
    {
      id: 5,
      type: 'link',
      text: 'Pricing',
      isAuthenticated: false,
      isActive: false,
      path: '/subscription',
      defaultIcon: PricingIcon,
      activeIcon: PricingActive,
    },
    
    // { id: 6, type: 'break', isAuthenticated: false },
    // {
    //   id: 7,
    //   type: 'link',
    //   text: 'Contact Us',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/contact',
    //   defaultIcon: ContactUsIcon,
    //   activeIcon: ContactUsActive,
    // },
    // {
    //   id: 8,
    //   type: 'link',
    //   text: 'Help & Support',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/help',
    //   defaultIcon: HelpIcon,
    //   activeIcon: HelpActive,
    // },
    // { id: 9, type: 'break', isAuthenticated: true },
    // {
    //   id: 10,
    //   type: 'link',
    //   text: 'User Setting',
    //   isAuthenticated: true,
    //   isActive: false,
    //   path: '/user-setting',
    //   defaultIcon: UserSettingIcon,
    //   activeIcon: UserSettingActive,
    // },
    {
      id: 11,
      type: 'handleAuthentication',
      text: 'Logout',
      isAuthenticated: false,
      isActive: false,
      path: '/help',
    },
    
    
  ];

  const [menuContent, setMenuContent] = useState(initialMenuContent);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const [searchParams] = useSearchParams();
  const {
    user: { userEmail },
    isAuthenticated,
  } = useAuthContext();
  const dispatch = useDispatch();
  const {
    credits: { free: freeCredits, paid: paidCredits },
  } = useCreditContext();

  useEffect(() => {
    const filterUnauthenticated = (content) => {
      return content.filter((item) => !item.isAuthenticated);
    };
    const updateActiveStatus = (content) => {
      return content.map((item) => {
        let isActive;
        if (item.text === 'Credit') {
          isActive =
            location.pathname === '/user-setting' &&
            searchParams.get('from') === 'credit';
        } else if (item.text === 'User Setting') {
          isActive =
            location.pathname === '/user-setting' && !searchParams.get('from');
        } else {
          isActive = location.pathname === item.path;
        }
        return {
          ...item,
          isActive,
        };
      });
    };

    if (!userEmail && !isAuthenticated) {
      setMenuContent(filterUnauthenticated(initialMenuContent));
    } else {
      setMenuContent(initialMenuContent);
    }
    setMenuContent((prevContent) => updateActiveStatus(prevContent));
  }, [userEmail, isAuthenticated, location]);

  const handleLogout = () => {
    logout();
    dispatch(resetForStepWiseUserData({}));
  };

  return (
    <div className="menu_list_wrapper">
      <div className="header_container">
        <div className="metaModel_logo_wrapper">
          {/* <img src={metaModelLogo} alt="meta_model_logo" /> */}
        </div>
        
        <div className="close_model_wrapper">
          <img
            src={closeCrossIcon}
            alt="closeCrossIcon"
            onClick={handleClose}
          />
        </div>
      </div>
      <div className="menu_list_wrapper">
      
        <div className="list_content">
          <div className="btn_wrapper">
            <button
              onClick={() => navigate('/')}
              className={`create_new_image_btn ${
                isAuthenticated ? 'crt_image_btn' : ''
              }`}
            >
              Create Request
             
            </button>
            {!isAuthenticated && (
              <button
                className="mobile_login_btn"
                onClick={() => navigate('/login')}
              >
                <img src={logInIcon} alt="loginIcon" /> Login
              </button>
            )}
            
          </div>
          
          <div className="action_wrapper">
            {menuContent.map((content, index) => {
              return content.type == 'break' ? (
                <div className="break" />
              ) : content.type == 'link' ? (
                <div className="link">
                  <Link
                    to={content.path}
                    className={`${content.isActive ? 'active-link' : ''}`}
                  >
                    <img
                      src={
                        content.isActive
                          ? content.activeIcon
                          : content.defaultIcon
                      }
                      alt={content.text}
                    />
                    {'  '}
                    {content.text}
                    {`${
                      content.text == 'Credit'
                        ? ': ' + Number((freeCredits ?? 0) + (paidCredits ?? 0))
                        : ''
                    }`}
                  </Link>
                  
                </div>
                
              ) : content.type == 'handleAuthentication' ? (
                isAuthenticated && (
                  <div className="link">
                    <Link onClick={handleLogout}>
                      <img src={LogoutIcon} alt="logout" /> {content.text}
                    </Link>
                  </div>
                )
              ) : (
                ''
              );
            })}
      
      {/* <GoogleCalendarButton calendar={`menu-button`}/> */}
          </div>
          
        </div>
      </div>
    </div>
  );
};
export default MobileMenu;
